import { createApp } from "vue";
import "./css/style.css";
import App from "./App.vue";
// import { VueReCaptcha } from 'vue-recaptcha-v3'
import { install } from "vue3-recaptcha-v2";

import { recaptcha_v2_site_key } from "./constants/envrionment";

let app = createApp(App);
// app.use(VueReCaptcha, {
//     siteKey: recaptcha_site_key
// })
app.use(install, {
    sitekey: recaptcha_v2_site_key,
    cnDomains: false, // Optional, If you use in China, set this value true
})
app.mount("#quoteHolder");





